<template>
  <div>
    <label
      class="block mb-4"
      :class="[themes_labes[theme]]"
      v-if="label"
    >
     <span v-html="label"></span>
    <span v-if="required" class="obligatoire">*</span>
    </label>
    <input
      class="border border-grey rounded w-full mb-5 p-3 text-grey-darker leading focus:outline-none"
      v-model="url"
      :disabled="disabled"
      placeholder="http://www.exemple.tn"
    />
  </div>
</template>
<script>
export default {
  name: "sp-url",
  data() {
    return {
      testUrl: false,
      videoThumb: "",
      themes: {
        default: "",
        form:
          "border border-blue-light2 focus:border-blue-light focus:shadow-sm rounded text-grey-darker leading-tight",
        dark: "button--dark"
      },
      themes_labes: {
        default: "",
        form: "text-blue text-2sm mb-4",
        dark: "button--dark"
      }
    };
  },
  props: {
    label: String,
    url: {
      type: String,
      default: ""
    },
    theme: {
      required: false,
      type: String,
      default: ""
    },
    disabled: {
      required: false,
      type: Boolean,
      default: false
    },
    required: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    validateUrl() {
      let regex = /^((https?|ftp|smtp):\/\/)?(www.)?[a-z0-9]+(\.[a-z]{2,}){1,3}(#?\/?[a-zA-Z0-9#]+)*\/?(\?[a-zA-Z0-9-_]+=[a-zA-Z0-9-%]+&?)?$/;

      if (this.url.match(regex)) {
        this.testUrl = true;
      } else this.testUrl = false;
    }
  },
  watch: {
    url: function(newurl, oldurl) {
      this.validateUrl();
      this.$emit("update", newurl);
    }
  },
  created() {
    this.validateUrl();
  }
};
</script>
